<script setup lang="ts">
import { Button } from '@/components/ui/button'
import { useRouter } from 'vue-router'
import AuthLayout from '@/components/layout/AuthLayout.vue'

const router = useRouter()

const goBack = () => {
  router.back()
}
</script>

<template>
  <AuthLayout title="Terms and Conditions">
    <div class="max-w-4xl mx-auto space-y-6 py-8">
      <div class="flex flex-col items-center mb-8">
        <h1 class="text-3xl font-bold text-center">Terms and Conditions</h1>
        <p class="mt-4 text-center text-gray-600">
          Last updated:
          {{
            new Date().toLocaleDateString('en-IE', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })
          }}
        </p>
      </div>

      <div class="prose prose-slate max-w-none">
        <h2>1. Introduction</h2>
        <p>
          Welcome to Maximo. These Terms and Conditions govern your use of our
          web application and services for pension contribution management and
          tax refund processing. By using our services, you agree to these terms
          in full. If you disagree with any part of these terms, please do not
          use our services.
        </p>

        <h2>2. Definitions</h2>
        <p>
          <strong>"Service"</strong> refers to the Maximo web application.<br />
          <strong>"User"</strong> refers to individuals who register and use our
          services.<br />
          <strong>"Content"</strong> refers to all information and data
          submitted by users or displayed on our platform.
        </p>

        <h2>3. Account Registration</h2>
        <p>
          To use our services, you must register an account by providing
          accurate and complete information. You are responsible for maintaining
          the confidentiality of your account credentials and for all activities
          that occur under your account. You must immediately notify us of any
          unauthorized use of your account.
        </p>

        <h2>4. Privacy and Data Protection</h2>
        <p>
          We collect and process personal data in accordance with our Privacy
          Policy. By using our services, you consent to such processing and you
          warrant that all data provided by you is accurate and complete.
        </p>

        <h2>5. User Obligations</h2>
        <p>You agree to:</p>
        <ul>
          <li>Provide accurate information when using our services</li>
          <li>Use the service only for lawful purposes</li>
          <li>
            Not engage in any activity that interferes with or disrupts the
            service
          </li>
          <li>
            Not attempt to gain unauthorized access to any part of the service
          </li>
        </ul>

        <h2>6. Pension Contribution Management</h2>
        <p>
          Our service facilitates pension contribution management. We do not
          provide financial advice, and all decisions regarding pension
          contributions are solely your responsibility. We recommend consulting
          with a financial advisor before making significant financial
          decisions.
        </p>

        <h2>7. Tax Refund Processing</h2>
        <p>
          Our service assists with Form 11 tax refund processing. While we
          strive to provide accurate information, we do not guarantee the
          success of any tax refund application. You remain responsible for the
          accuracy of all information submitted to tax authorities.
        </p>

        <h2>8. Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, we exclude all
          representations, warranties, and guarantees relating to our service.
          Our liability is limited to the amount you have paid for our services,
          and we will not be liable for any indirect, special, or consequential
          loss.
        </p>

        <h2>9. Changes to Terms</h2>
        <p>
          We reserve the right to modify these terms at any time. We will
          provide notice of significant changes. Your continued use of the
          service after such modifications constitutes your acceptance of the
          updated terms.
        </p>

        <h2>10. Governing Law</h2>
        <p>
          These terms are governed by and construed in accordance with the laws
          of Ireland. Any disputes relating to these terms shall be subject to
          the exclusive jurisdiction of the courts of Ireland.
        </p>
      </div>

      <div class="flex justify-center mt-8">
        <Button @click="goBack" class="px-8"> Back </Button>
      </div>
    </div>
  </AuthLayout>
</template>
